<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter"><em>Contents</em></h1>
<p class="toc1"><a class="hlink" href="#/OEBPS/Dedication.htm">DEDICATION</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/prologue.htm">PROLOGUE</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/part1.htm">I. A CHANCE TO LIVE</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/ch01.htm">Wednesday, May 3, 1939, to</a> <a class="hlink" href="#/OEBPS/ch17.htm">Thursday, May 25, 1939</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/part2.htm">II. A CHANCE TO DIE</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/ch18.htm">Friday, May 26, 1939, to</a> <a class="hlink" href="#/OEBPS/ch24.htm">Thursday, June 1, 1939</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/part3.htm">III. THE FINAL SOLUTION</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/ch25.htm">Friday, June 2, 1939, to</a> <a class="hlink" href="#/OEBPS/ch42.htm">Wednesday, June 21, 1939</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/epilogue.htm">EPILOGUE</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/appendices.htm">APPENDICES</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3bb4488e